export default "__VITE_ASSET__Dtv2Ly5e__"